import React, { useState } from "react";
import Slider from "react-rangeslider";
import Checkbox from "./Checkbox";
import { ACTION_TYPES } from "./ActionTypes";

export default function AdvancedSearchForm({
  searchText,
  dispatch,
  attributes,
  markets,
  regions,
  slashsheets,
  tg,
  td,
  dk,
  df,
  uniqueTgValues,
  uniqueTdValues,
  uniqueDkValues,
  uniqueDfValues,
}) {
  const [slashSheetOpen, setSlashSheetOpen] = useState(false);

  const toggleSlashSheet = () => {
    setSlashSheetOpen((prev) => !prev);
  };

  const handleChange = (e) => {
    dispatch({
      type: ACTION_TYPES.SET_SEARCH_TEXT,
      payload: e.target.value,
    });
  };

  const maxTg = Math.max(...uniqueTgValues);
  const maxTd = Math.max(...uniqueTdValues);
  const maxDk = Math.max(...uniqueDkValues);
  const maxDf = Math.max(...uniqueDfValues);

  const minTg = Math.min(...uniqueTgValues);
  const minTd = Math.min(...uniqueTdValues);
  const minDk = Math.min(...uniqueDkValues);
  const minDf = Math.min(...uniqueDfValues);

  return (
    <div className="p-10 bg-white">
      <label htmlFor="search" className="flex items-center mb-5">
        <span className="mb-1 pr-4 font-sans text-lg font-bold tracking-wide uppercase text-theme-gray">
          Search:
        </span>
        <input
          value={searchText}
          className="w-full px-4 py-3 font-sans leading-tight bg-white border border-theme-gray appearance-none focus:outline-none focus:bg-white focus:border-gray-500"
          onChange={handleChange}
          type="text"
          id="search"
        />
      </label>
      <div className=" ">
        <div className="accordion-tabs">
          <div className="accordion-tab">
            <input type="checkbox" id="chck1" />
            <label
              className="px-auto font-sans text-lg font-bold tracking-wide uppercase text-theme-red accordion-tab-label hover:text-theme-gray"
              htmlFor="chck1"
            >
              Show Filter Options
            </label>
            <div className="accordion-tab-content flex flex-col md:flex-row flex-wrap  border border-gray-200">
              <div className="p-5 bg-light-gray w-full md:w-1/2 lg:w-1/4 border-b-4 border-r-4 border-white attributes">
                <h2 className="text-base text-theme-red text-center mb-2">
                  Attributes
                </h2>
                {attributes.map((facet) => {
                  return (
                    <Checkbox
                      key={facet.title}
                      id={facet.title}
                      className="flex items-center font-medium leading-8"
                      onChange={() => {
                        dispatch({
                          type: ACTION_TYPES.TOGGLE_CHECKBOX_BY_ID_TYPE,
                          payload: {
                            id: facet.id,
                            key: "attributes",
                          },
                        });
                      }}
                      checked={!!facet.checked}
                      text={facet.title}
                    />
                  );
                })}

                <Checkbox
                  className="flex items-center font-medium leading-8"
                  onChange={(e) => {
                    dispatch({
                      type: ACTION_TYPES.TOGGLE_ALL_CHECKBOX_TYPE,
                      payload: {
                        checked: e.target.checked,
                        key: "attributes",
                      },
                    });
                  }}
                  text="Select All"
                />
              </div>
              <div className="p-5 bg-light-gray w-full md:w-1/2 lg:w-1/4 border-b-4 border-r-4 border-white market-segment">
                <h2 className="text-base text-theme-red text-center mb-2">
                  Market Segment
                </h2>
                {markets.map((facet) => {
                  return (
                    <Checkbox
                      key={facet.title}
                      className="flex items-center font-medium leading-8"
                      onChange={() => {
                        dispatch({
                          type: ACTION_TYPES.TOGGLE_CHECKBOX_BY_ID_TYPE,
                          payload: {
                            id: facet.id,
                            key: "markets",
                          },
                        });
                      }}
                      checked={!!facet.checked}
                      text={facet.title}
                    />
                  );
                })}

                <Checkbox
                  className="flex items-center font-medium leading-8"
                  onChange={(e) => {
                    dispatch({
                      type: ACTION_TYPES.TOGGLE_ALL_CHECKBOX_TYPE,
                      payload: {
                        checked: e.target.checked,
                        key: "markets",
                      },
                    });
                  }}
                  text="Select All"
                />
              </div>
              <div className="flex flex-wrap w-full md:w-1/2">
                <div className="p-5 bg-light-gray w-1/2 border-b-4 border-r-4 border-white thermal-performance">
                  <h2 className="text-base text-theme-red text-center mb-2">
                    Thermal Performance
                  </h2>

                  <div className="label">Tg: &ge; {tg}&deg;C</div>
                  <Slider
                    min={minTg}
                    max={maxTg}
                    value={tg}
                    orientation="horizontal"
                    onChange={(val) => {
                      dispatch({
                        type: ACTION_TYPES.SET_TG_VALUE,
                        payload: val,
                      });
                    }}
                  />

                  <div className="label">Td: &ge; {td}&deg;C</div>
                  <Slider
                    min={minTd}
                    max={maxTd}
                    value={td}
                    orientation="horizontal"
                    onChange={(val) => {
                      dispatch({
                        type: ACTION_TYPES.SET_TD_VALUE,
                        payload: val,
                      });
                    }}
                  />
                </div>
                <div className="p-5 bg-light-gray w-1/2 border-b-4 border-white electrical-performance">
                  <h2 className="text-base text-theme-red text-center mb-2">
                    Electrical Performance
                  </h2>

                  <div className="label">Dk: &le; {dk}</div>
                  <Slider
                    min={minDk}
                    max={maxDk}
                    step={0.05}
                    value={dk}
                    orientation="horizontal"
                    onChange={(val) => {
                      dispatch({
                        type: ACTION_TYPES.SET_DK_VALUE,
                        payload: val,
                      });
                    }}
                  />
                  <div className="label">Df: &le; {df}</div>
                  <Slider
                    min={minDf}
                    max={maxDf}
                    step={0.001}
                    value={df}
                    orientation="horizontal"
                    onChange={(val) => {
                      dispatch({
                        type: ACTION_TYPES.SET_DF_VALUE,
                        payload: val,
                      });
                    }}
                  />
                </div>

                <div className="p-5 w-full border-b-4 border-white bg-light-gray region">
                  <h2 className="text-base text-theme-red text-center mb-2">
                    Region
                  </h2>

                  <div className="flex flex-wrap">
                    {regions.map((facet) => {
                      return (
                        <Checkbox
                          key={facet.title}
                          className="flex items-center font-medium leading-8 w-1/2"
                          onChange={() => {
                            dispatch({
                              type: ACTION_TYPES.TOGGLE_CHECKBOX_BY_ID_TYPE,
                              payload: {
                                id: facet.id,
                                key: "regions",
                              },
                            });
                          }}
                          checked={!!facet.checked}
                          text={facet.title}
                        />
                      );
                    })}

                    <Checkbox
                      className="flex items-center font-medium leading-8 w-1/2"
                      onChange={(e) => {
                        dispatch({
                          type: ACTION_TYPES.TOGGLE_ALL_CHECKBOX_TYPE,
                          payload: {
                            checked: e.target.checked,
                            key: "regions",
                          },
                        });
                      }}
                      text="Select All"
                    />
                  </div>
                </div>
              </div>

              <div className="w-full">
                <button
                  className="text-theme-red text-sm font-thin hover:underline"
                  onClick={toggleSlashSheet}
                >
                  Search by Slashsheet
                </button>
              </div>

              {slashSheetOpen && (
                <div className="p-5 w-full md:w-1/2 border-r-4 border-white bg-light-gray slash-sheet">
                  <h2 className="text-base text-theme-red text-center mb-2">
                    Slash Sheet
                  </h2>

                  <div className="flex flex-wrap">
                    {slashsheets.map((facet) => {
                      return (
                        <Checkbox
                          key={facet.title}
                          className="flex items-center font-medium leading-8 w-1/6"
                          onChange={() => {
                            dispatch({
                              type: ACTION_TYPES.TOGGLE_CHECKBOX_BY_ID_TYPE,
                              payload: {
                                id: facet.id,
                                key: "slashsheets",
                              },
                            });
                          }}
                          checked={!!facet.checked}
                          text={facet.title}
                        />
                      );
                    })}

                    <Checkbox
                      className="flex items-center font-medium leading-8 w-1/6"
                      onChange={(e) => {
                        dispatch({
                          type: ACTION_TYPES.TOGGLE_ALL_CHECKBOX_TYPE,
                          payload: {
                            checked: e.target.checked,
                            key: "slashsheets",
                          },
                        });
                      }}
                      text="Select All"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
